module.exports = __webpack_public_path__ + "static/img/circle_active.da2510d5.svg";